/** ISO 8601 の日時文字列（時刻あり）にマッチ */
const ISO_DATE_TIME_PATTERN = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/;

/**
 * ISO 8601 日時文字列を Date に変換する。日時として解釈できなければ null。
 * 時刻を含まない date-only（yyyy-MM-dd）は対象外（`parseISODate` を使う）。
 */
export function parseISODateTime(value: string): Date | null {
  if (!ISO_DATE_TIME_PATTERN.test(value)) {
    return null;
  }
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}